export default __webpack_public_path__ + "static/media/category.5c32a2a2.png";